<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 302 73.942"
    fill="none"
    :role="label ? 'img' : null"
    :aria-label="label"
    :aria-hidden="label ? null : 'true'"
  >
    <path
      d="M 11.898 27.258 C 15.458 23.596 21.356 20.647 27.661 20.647 C 43.221 20.647 52.679 32.445 52.679 47.295 C 52.679 62.144 41.898 73.942 27.152 73.942 C 20.542 73.942 14.441 70.789 11.695 67.331 L 10.373 72.722 L 0 72.722 L 0 0 L 11.898 0 L 11.898 27.258 Z M 118.603 20.647 C 134.162 20.648 143.619 31.428 143.619 46.277 C 143.619 47.6 143.518 49.634 143.314 50.854 L 105.179 50.854 C 105.585 58.381 111.382 63.161 119.518 63.161 C 125.416 63.161 128.976 60.619 132.026 55.432 L 141.992 59.805 C 138.229 68.246 129.687 73.942 118.501 73.942 C 102.942 73.942 93.382 62.144 93.382 47.295 C 93.382 32.445 103.043 20.647 118.603 20.647 Z M 175.979 20.647 C 191.538 20.647 200.996 31.428 200.996 46.277 C 200.996 47.599 200.895 49.634 200.691 50.854 L 162.555 50.854 C 162.961 58.381 168.759 63.161 176.895 63.161 C 182.793 63.161 186.352 60.619 189.402 55.432 L 199.369 59.805 C 195.606 68.247 187.063 73.942 175.877 73.942 C 160.318 73.942 150.759 62.144 150.759 47.295 C 150.759 32.446 160.419 20.648 175.979 20.647 Z M 276.982 20.647 C 292.542 20.647 302 31.428 302 46.277 C 302 47.599 301.899 49.634 301.695 50.854 L 263.56 50.854 C 263.966 58.381 269.763 63.161 277.898 63.161 C 283.797 63.161 287.355 60.619 290.406 55.432 L 300.373 59.805 C 296.61 68.247 288.067 73.942 276.881 73.942 C 261.322 73.942 251.763 62.144 251.763 47.295 C 251.763 32.446 261.423 20.648 276.982 20.647 Z M 84.575 20.647 C 87.219 20.647 89.456 21.054 91.389 21.664 L 88.948 33.869 C 87.219 33.462 84.676 32.954 82.643 32.954 C 75.829 32.954 71.863 37.734 71.863 46.074 L 71.863 72.722 L 59.965 72.722 L 59.965 21.867 L 70.338 21.867 L 71.66 28.377 C 74.609 23.393 79.389 20.647 84.575 20.647 Z M 246.988 31.632 L 222.072 61.94 L 247.699 61.94 L 247.699 72.722 L 207.225 72.722 L 207.225 62.958 L 231.937 32.648 L 209.259 32.648 L 209.259 21.867 L 246.988 21.867 L 246.988 31.632 Z M 26.034 31.428 C 17.39 31.428 10.576 38.243 10.576 47.295 C 10.576 56.347 16.881 63.161 25.525 63.161 C 33.966 63.161 40.576 56.347 40.576 47.295 C 40.576 38.243 34.678 31.428 26.034 31.428 Z M 118.704 31.428 C 111.484 31.428 105.687 35.903 105.179 41.904 L 131.619 41.904 C 131.212 35.7 125.924 31.428 118.704 31.428 Z M 176.081 31.428 C 168.861 31.428 163.063 35.903 162.555 41.904 L 188.996 41.904 C 188.589 35.7 183.301 31.428 176.081 31.428 Z M 277.085 31.428 C 269.865 31.428 264.068 35.903 263.56 41.904 L 290 41.904 C 289.593 35.7 284.305 31.428 277.085 31.428 Z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
const RATIO = 302 / 73.942

// The Breeze wordmark, ported from the support dashboard's BreezeLogo. Takes its colour
// from `currentColor`, so set `color` on the element or a parent.
export default {
  name: 'DsBreezeLogo',
  props: {
    height: {
      type: Number,
      default: 22,
    },
    // Pass null when a labelled wrapper (e.g. a link) already names it, so it isn't
    // announced twice.
    label: {
      type: String,
      default: 'Breeze',
    },
  },
  computed: {
    width() {
      return this.height * RATIO
    },
  },
}
</script>
